(function () {
    'use strict';
    /* directive with list of agendaItems for one day for one agenda */
    var module = angular.module('uwAgenda.agenda');
    module.directive('agendaDay', [AgendaDayDirectiveFn]);

    function AgendaDayDirectiveFn() {
        var directive = {
            restrict: 'E',
            templateUrl: '/app/agenda/templates/agenda-day.template.html',
            controller: 'AgendaDayController',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                date: '=',
                timeItems: '=',
                showConfirmed: '@',
                daysInWeek: '@?' // number of days in week to show
            }
        };
        return directive;       
    }
})();